import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, { formatLatexPreview } from "../../../../components/inputs/FractionInput";
import InlineKeepTogether from "../../../../components/ui/InlineKeepTogether";
import { checkFractionAnswer, latexFrac, makeUid, pick, simplify } from "./probabilityEventUtils";

function makeData() {
  const denominator = pick([12, 15, 18, 20, 24]);
  const a = pick([2, 3, 4, 5, 6]);
  const maxB = denominator - a - 2;
  const b = pick(Array.from({ length: Math.max(2, maxB - 1) }, (_, i) => i + 2));
  const answer = simplify(a + b, denominator);
  return { denominator, a, b, answer };
}

export function generateTask() {
  return {
    type: "DisjointEventsUnionTask",
    uid: makeUid("prob_disjoint_union"),
    data: makeData()
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ textAlign: "left", margin: "12px 0" }}>
      Zdarzenia <InlineMath math="A" /> i <InlineMath math="B" /> są rozłączne. Wiadomo, że{" "}
      <InlineMath math={`P(A)=${latexFrac(data.a, data.denominator)}`} /> oraz{" "}
      <InlineKeepTogether>
        <InlineMath math={`P(B)=${latexFrac(data.b, data.denominator)}`} />.
      </InlineKeepTogether>{" "}
      Oblicz{" "}
      <InlineKeepTogether>
        <InlineMath math={"P(A\\cup B)"} />.
      </InlineKeepTogether>
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  return (
    <div className="flex items-center gap-3">
      <InlineMath math={"P(A\\cup B) = "} />
      <FractionInput value={userAnswer} onChange={onChange} disabled={disabled} label={"P(A\\cup B)"} placeholder="np. 3/4" />
    </div>
  );
}

export function checkAnswer({ data }, userAnswer) {
  return checkFractionAnswer(data.answer, userAnswer);
}

export function renderAnswer({ data }) {
  return <InlineMath math={`P(A\\cup B)=${latexFrac(data.answer[0], data.answer[1])}`} />;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={formatLatexPreview(userAnswer.raw, "P(A\\cup B)")} />;
}

export function renderExplanation({ data }) {
  return (
    <div style={{ textAlign: "left", lineHeight: 1.75 }}>
      <p><strong>Krok 1.</strong> Zdarzenia rozłączne nie mają części wspólnej.</p>
      <BlockMath math={"P(A\\cap B)=0"} />
      <p><strong>Krok 2.</strong> Dlatego prawdopodobieństwa dodajemy.</p>
      <BlockMath math={`P(A\\cup B)=P(A)+P(B)=${latexFrac(data.a, data.denominator)}+${latexFrac(data.b, data.denominator)}=${latexFrac(data.answer[0], data.answer[1])}`} />
      <p><strong>Odpowiedź:</strong> <InlineKeepTogether><InlineMath math={`P(A\\cup B)=${latexFrac(data.answer[0], data.answer[1])}`} />.</InlineKeepTogether></p>
    </div>
  );
}
